module.exports = __webpack_public_path__ + "fonts/DINNextLTPro-Italic.0019e0c1.woff2";